import { useView } from '../../../hooks/useView';
import { channels } from '../../../test.data';
import Accordion from '../../accordion/accordion';
import AccordionOption from '../../accordion/option.accordion';
import Button from '../../button/v2/button';
import HorizontalBar from '../../horizontalBar';
import Avatar from '../../images/avatar';
import { HStack, VStack } from '../../layouts/stack.layout';
import MembersList from '../../lists/member.list';
import Text from '../../typography/v2/text';
import { CHANNEL_INFO_VIEW } from '../../views/alt-channel-info/support';

type Props = {
  id: string;
};

export default function DetailsContainer({ id }: Props) {
  const [, update] = useView('');
  const channel = channels.find((c) => c.id === id);

  return (
    <VStack extensions="w-full">
      <VStack
        extensions="w-full border-b border-dark-gray py-3"
        gap="sm"
        align="center"
      >
        {channel?.backgroundImage && channel.title && (
          <Avatar size="lg" url={channel.backgroundImage} alt={channel.title} />
        )}
        <HStack
          extensions="cursor-pointer items-center border border-light-gray px-3 py-1.5 rounded-full hover:bg-white/[25%] ease-in transition-colors"
          gap="sm"
        >
          <div className="w-2 h-2 rounded-full bg-green-500" />
          <Text>{5} Members Online</Text>
        </HStack>
      </VStack>

      <Accordion className="w-full">
        {channel?.description && (
          <AccordionOption value="details">
            <AccordionOption.Trigger>
              <Text variant="navigation">Details</Text>
            </AccordionOption.Trigger>
            <AccordionOption.Content>
              <Text>{channel.description}</Text>
            </AccordionOption.Content>
          </AccordionOption>
        )}

        <AccordionOption value="media">
          <AccordionOption.Trigger>
            <Text variant="navigation">Media & Links</Text>
          </AccordionOption.Trigger>
          <AccordionOption.Content>
            <Text>No media or links</Text>
          </AccordionOption.Content>
        </AccordionOption>

        <AccordionOption value="members">
          <AccordionOption.Trigger>
            <Text variant="navigation">Members</Text>
          </AccordionOption.Trigger>
          <AccordionOption.Content>
            <VStack gap="sm" extensions="w-full px-3">
              <MembersList query="ONLINE" params={{ maxCount: 5, id: id }} />
              <HorizontalBar color="light-gray" />
              <ViewMoreButton
                onClick={() => update(CHANNEL_INFO_VIEW.MEMBERS)}
              />
            </VStack>
          </AccordionOption.Content>
        </AccordionOption>

        <AccordionOption value="preferences">
          <AccordionOption.Trigger>
            <Text variant="navigation">Preferences</Text>
          </AccordionOption.Trigger>
          <AccordionOption.Content>
            <div>Preferences</div>
          </AccordionOption.Content>
        </AccordionOption>
      </Accordion>
    </VStack>
  );
}

type ViewMoreButtonProps = {
  onClick: Function;
};

function ViewMoreButton({ onClick }: ViewMoreButtonProps) {
  return (
    <HStack justify="center" extensions="w-full">
      <Button onClick={onClick} size="sm" variant="text">
        View More
      </Button>
    </HStack>
  );
}
